import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BasicBanner from './templates/BasicBanner';
import ReactMarkdown from '../../shared/components/MarkdownRenderers/CustomReactMarkdown';
import Link from '../../shared/components/Link/Link';


class HeaderBanner extends Component {
  static getDomId() {
    return 'slot_header_banner';
  }

  render() {
    const { messages, supportLinks, navigationLinks } = this.props;

    // TODO -- remove BasicBanner template once all sites are migrated to new promo banner
    if (!messages && !supportLinks) {
      return (<BasicBanner {...this.props} />);
    }

    const sortItems = items => items.sort((itemA, itemB) => itemA.sort - itemB.sort);

    return (
      <div className="site-header__banner-wrapper">
        <div className="se-container">
          <div className="site-banner">
          { 
            navigationLinks && (
              <div className="site-banner__navigation-links">
                {sortItems(navigationLinks).map(({
                  id, url, external, display,
                }) => (
                  <Link
                    key={id}
                    href={url}
                    external={external}
                    className="site-banner__navigation-link"
                  >
                    {display}
                  </Link>
                ))}
              </div>
          )}
            {messages && <div className="site-banner__messages">
              {sortItems(messages).map(({ id, message }) => (
                <ReactMarkdown key={id} className="site-banner__message" source={message} />
              ))}
            </div>}
            {supportLinks && <div className="site-banner__support-links">
              {sortItems(supportLinks).map(({
                id, url, external, display,
              }) => (
                <Link
                  key={id}
                  href={url}
                  external={external}
                  className="site-banner__support-link"
                >
                  {display}
                </Link>
              ))}
            </div>}

          </div>
        </div>
      </div>
    );
  }
}

HeaderBanner.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    sort: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
  })).isRequired,
  navigationLinks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    sort: PropTypes.number.isRequired,
    external: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
  })), 
  supportLinks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    sort: PropTypes.number.isRequired,
    external: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
};

export default HeaderBanner;
